import header from "./woman-with-keys.png";
import section1 from "./signing-contract.png";
import section2 from "./reading-record-of-delivery.png";
import section3 from "./writing-record-of-delivery.png";
import section4 from "./pointing-at-record-of-delivery.png";
import section5 from "./gesetzesbuecher-mit-laptop.png";
import section6 from "./record-of-delivery.webp";
import section7 from "./give-record-of-delivery.png";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
